import { render, staticRenderFns } from "./add.vue?vue&type=template&id=68d97a58&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d97a58')) {
      api.createRecord('68d97a58', component.options)
    } else {
      api.reload('68d97a58', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=68d97a58&", function () {
      api.rerender('68d97a58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/system-manage/role-manage/add.vue"
export default component.exports